import { Options } from 'highcharts';
import { e2mTheme } from '@e2m-customer-portal/theme';

/**
 * These are default options for all Highcharts charts. They can be overwritten per-chart.
 */
export const options: Options = {
  exporting: { enabled: false },
  title: { text: undefined },
  time: {
    timezoneOffset: new Date().getTimezoneOffset(),
    useUTC: false,
  },
  yAxis: {
    min: 0,
    title: { text: undefined },
  },
  colors: e2mTheme.palette.charts.colors,
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
};
